export default __webpack_public_path__ + "static/media/value-record.47ff0e60.svg";